export { default, type IconProps } from './Icon';
